import { useTrackingConfig } from '@ad-lucy/context/tracking';
import { detectBotClick } from '@ad-lucy/hooks/tracking/useTracker/utils';
import { GlobalPayout, type TrackingInformation } from '@ad-lucy/utils';
import { useCallback } from 'react';

type UseGetPayoutReturnValue = (trackingInformation: TrackingInformation) => boolean;

export const useGetPayout = (): UseGetPayoutReturnValue => {
  const trackingConfig = useTrackingConfig();

  const globalPayout =
    trackingConfig?.forceGlobalPayout ?? trackingConfig?.globalTrackingMetaData?.globalPayout;

  return useCallback(
    (trackingInformation) => {
      const {
        external,
        payout,
        defaultPayout = trackingInformation.payout,
        event,
      } = trackingInformation;
      const payoutResult = payout ?? defaultPayout ?? false;

      if (detectBotClick(trackingInformation)) return false;

      switch (globalPayout) {
        case GlobalPayout.NONE:
          return payoutResult;
        case GlobalPayout.PAYOUT_ON_LINKOUT:
          return external && !!defaultPayout;
        case GlobalPayout.NO_PAYOUT_ON_HOVER:
          return event !== 'Hover' && payoutResult;
        default:
          return payoutResult;
      }
    },
    [globalPayout],
  );
};
